import { CaseEditorPage } from '@/pages/case-editor';

export function NewCasePage() {
  return <CaseEditorPage />;
}
